import React from "react";

export function OpenFacesheetIcon() {
    return <svg
        width="15px"
        height="15px"
        viewBox="0 0 15 15"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Marketplace-(Approved)" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="CM--Marketplace" transform="translate(-420.000000, -155.000000)" fill="#1A72E5">
                <g id="Facesheet" transform="translate(165.000000, 129.000000)">
                    <g id="Patient-Details" transform="translate(19.000000, 25.000000)">
                        <path
                            d="M249.333333,14.3333333 L237.666667,14.3333333 L237.666667,2.66666667 L243.5,2.66666667 L243.5,1 L237.666667,1 C236.741667,1 236,1.75 236,2.66666667 L236,14.3333333 C236,15.25 236.741667,16 237.666667,16 L249.333333,16 C250.25,16 251,15.25 251,14.3333333 L251,8.5 L249.333333,8.5 L249.333333,14.3333333 L249.333333,14.3333333 Z M245.44864,1 L245.44864,2.58610272 L248.295695,2.58610272 L240.5,10.3817976 L241.618202,11.5 L249.413897,3.70430514 L249.413897,6.55135952 L251,6.55135952 L251,1 L245.44864,1 L245.44864,1 Z"
                            id="icon:expand"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>;
}
